import { type EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { COUNTDOWN_PORT } from '@core/ports';

import { CountdownService } from './countdown.service';

export function provideCountdown(): EnvironmentProviders {
  return makeEnvironmentProviders([{ provide: COUNTDOWN_PORT, useExisting: CountdownService }]);
}
